import { render, staticRenderFns } from "./gardening-page.vue?vue&type=template&id=24d7e42f&lang=pug&"
import script from "./gardening-page.vue?vue&type=script&lang=js&"
export * from "./gardening-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports